import { useMutation } from '@tanstack/react-query';
import ApiService from 'src/services/ApiService';

export const useSaveTenantChecklistMutation = () => {
  return useMutation({
    mutationKey: ['/tenant-checklist-rules' as const],
    mutationFn: ApiService.checklist.saveTenantChecklist,
  });
};
